var $ = require('jquery');

"use strict";

var PLUGIN_NAME = "webslider";

// detekce IE https://gist.github.com/padolsey/527683
var ieVersion = (function(){

    var undef,
        v = 3,
        div = document.createElement('div'),
        all = div.getElementsByTagName('i');

    while (
        div.innerHTML = '<!--[if gt IE ' + (++v) + ']><i></i><![endif]-->',
            all[0]
        );

    return v > 4 ? v : undef;

}());

var DEFAULTS = {
    minScreenWidth: 768,
    data: [],
    slideContentFormatter: function(data) {
        var result = '';
        result += '<ul class="slider">';
        for (var i = 0; i < data.length; i++) {
            result += '<li>';

            if (data[i].motive && data[i].motiveMd && data[i].motiveXs) {
                result += '<picture class="thumbnail">';
                if (ieVersion == 9) {
                    result += '<video style="display: none;">';
                }
                result += '<source srcset="' + data[i].motiveMd + '" media="(min-width: 992px)">';
                result += '<source srcset="' + data[i].motiveXs + '" media="(min-width: 448px)">';
                result += '<img src="/img/spacer.gif" srcset="' + data[i].motive + '" alt>';
                if (ieVersion == 9) {
                    result += '</video>';
                }
                result += '</picture>';
            }

            result += '<div class="description">';
            result += '<div class="description-wrapper">';
            if (data[i].title && data[i].title != '' && data[i].description && data[i].description != '') {
                result += '<blockquote>';
                result += '<p>'+ data[i].description +'</p>';
                result += '<footer><p>'+ data[i].title +'</p></footer>';
                result += '</blockquote>';
            }
            if (data[i].link) {
                result += '<p class="buttons"><a href="' + data[i].link + '" class="btn btn-small">' + data[i].linkName + '</a></p>';
            }
            result += '</div>';
            result += '</div>';
            result += '</li>';

        }
        result += '</ul>';
        return result;
    },
    controlArrows: true,
    controlPoints: true,
    slideTime: 8000
};

// The actual plugin constructor
function WebSlider(element, options) {
    this.element = element;

    this.options = $.extend(true, {}, DEFAULTS, options);
    this._wWidth = window.innerWidth;

    this._defaults = DEFAULTS;
    this._name = PLUGIN_NAME;

    this._changeTimer = null;

    this.initialise();
}

/**
 * init
 */
WebSlider.prototype.initialise = function() {
    if (this._wWidth < this.options.minScreenWidth) {
        $(this.element).empty().hide();
        return false;
    }
    $(this.element).show();
    this.actualSlide = 0;

    if (this.options.data.length > 0) {
        this.renderSlides();
    }

    if (this.options.data.length > 1) {
        this.renderControls();
        this.startRotation();
    }
};

/**
 * read data and build slides list
 */
WebSlider.prototype.renderSlides = function() {
    var htmlResult = this.options.slideContentFormatter(this.options.data);
    $(this.element).html(htmlResult);
};

/**
 * render controls
 */
WebSlider.prototype.renderControls = function() {
    this.controlArrows = (this.options.controlArrows) ? this.renderControlArrows() : null;
    this.controlPoints = (this.options.controlPoints) ? this.renderControlPoints() : null;

    if (this.controlArrows) {
        $(this.element).append(this.controlArrows);
        this.bindControlArrows();
    }

    if (this.controlPoints) {
        $(this.element).append(this.controlPoints);
        this.bindControlPoints();
        this.updateControlPoints(this.actualSlide);
    }
};

/**
 * renders control arrows
 */
WebSlider.prototype.renderControlArrows = function() {
    var str = '';
    str += '<span class="glyphicon glyphicon-arrow-left3 slider-arrow prev"></span>';
    str += '<span class="glyphicon glyphicon-arrow-right3 slider-arrow next"></span>';
    return str;
};

/**
 * bind action to control arrows
 */
WebSlider.prototype.bindControlArrows = function() {
    var self = this;
    $('span.slider-arrow', $(this.element)).bind('click', function() {
        clearTimeout(this._changeTimer);
        if ($(this).hasClass('prev')) {
            self.rotate(self.actualSlide, 'prev');
        }

        if ($(this).hasClass('next')) {
            self.rotate(self.actualSlide, 'next');
        }
    });
};

/**
 * renders control points
 */
WebSlider.prototype.renderControlPoints = function() {
    var str = '<ul class="control-points">';
    for (var i = 0; i < this.options.data.length; i++) {
        str += '<li>' + i + '</li>'
    }
    str += '</ul>';
    return str;
};

/**
 * bind action to control points
 */
WebSlider.prototype.bindControlPoints = function() {
    var self = this;
    clearTimeout(this._changeTimer);

    $('.control-points>li', $(this.element)).bind('click', function() {
        self.changeSlide(self.actualSlide, $(this).text());
    });
};

/**
 *
 */
WebSlider.prototype.rotate = function(from, direction) {
    var newSlide = this.actualSlide;
    clearTimeout(this._changeTimer);
    if (direction == "prev") {
        newSlide--;
        newSlide = (newSlide < 0) ? this.options.data.length - 1 : newSlide;
    }

    if (direction == "next") {
        newSlide++;
        newSlide = (newSlide >= this.options.data.length) ? 0 : newSlide;
    }

    this.changeSlide(this.actualSlide, newSlide);
};

/**
 *
 * @param from
 * @param to
 */
WebSlider.prototype.changeSlide = function(from, to) {
    if (from == to) {
        return false;
    }
    $('>ul:first>li:eq(' + from + ')', $(this.element)).fadeOut();
    $('>ul:first>li:eq(' + to + ')', $(this.element)).fadeIn();
    this.actualSlide = to;
    this.updateControlPoints(this.actualSlide);
    this.startRotation();
};


/**
 * start
 */
WebSlider.prototype.startRotation = function() {
    var self = this;
    clearTimeout(this._changeTimer);
    this._changeTimer = setTimeout(function() {
        self.rotate(self.actualSlide, 'next');
    }, self.options.slideTime);
};

/**
 * sets the right controlPoint active
 */
WebSlider.prototype.updateControlPoints = function(index) {
    if (this.options.controlPoints) {
        $('.control-points li', $(this.element)).removeClass('active');
        $('.control-points li:eq(' + index + ')', $(this.element)).addClass('active');
    }
};

/**
 * decide, which methods will be "public"
 */
var API = {
    //action: WebSlider.prototype.action
};

/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 *         if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 *         if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[PLUGIN_NAME] = function(value) {
    var args = arguments;

    return this.each(function() {
        var $this = $(this);

        // get plugin instance
        var plugin = $this.data('plugin_' + PLUGIN_NAME);

        // if there's not, create one
        if (!plugin) {
            plugin = new WebSlider(this, value);
            $this.data('plugin_' + PLUGIN_NAME, plugin);
        }
        // if there is and first parameter is in predefined API methods, call it with rest of params
        else if (API[value]) {
            plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
        }
    });
};



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/web/jquery.webslider.js